import axiosInstance from "../../utils/axios";

const fetchPackages = async (values) => {
  try {
    const response = await axiosInstance.get("/packages", values);
    return { isStatus: true, data: response.data };
  } catch (err) {
    return { isStatus: false, data: null, message: err.message };
  }
};

const PackagesAPI = {
  fetchPackages,
};

export default PackagesAPI;
